import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from '../models/dialog.data';

@Injectable({ providedIn: 'root' })
export class DialogService {
  constructor(private dialog: MatDialog) {}

  openDialog<
    T extends DialogComponent<T, D, R>,
    D = T extends DialogComponent<T, infer DI, any> ? DI : never,
    R = T extends DialogComponent<T, any, infer RI> ? RI : never,
  >(component: ComponentType<T>, data: D = {} as D): MatDialogRef<T, R> {
    let config: MatDialogConfig<D> = { data };
    if (component?.prototype instanceof DialogComponent) {
      config = { ...config, ...component.prototype.dialogConfig() };
    } else {
      throw new Error(
        'DialogComponent must be an instance of DialogComponent. Add "extends DialogComponent" to the class.',
      );
    }

    return this.dialog.open<T, D, R>(component, config);
  }

  closeAll(): void {
    this.dialog.closeAll();
  }
}
